import axios from 'axios';
import {ApiResponse} from '@interface/common';
import {User} from '@interface/master/UserManagementIF';
import {MenuInfo} from '@interface/auth/MenuManagementIF';


export const getViewCmCode = async (props:any) => {
    const viewCmCode: {[key:string]: { [key: string]: string}} = {};
    for(const cmGroupCode of props.cmGroupCodeList) {
        const {data} = await axios.get<{[key:string]: { [key: string]: string}}>(`/api/common-code/${cmGroupCode}`);
        viewCmCode[cmGroupCode] = data.item;

    }
    return  viewCmCode;
};


export const getUserLoginInfo = async () => {
    const {data} = await axios.get<ApiResponse<User>>('/api/common/login-info');
    return data;
};



export const getUserMenuInfo = async () => {
    const {data} = await axios.get<ApiResponse<MenuInfo[]>>('/api/common/menu-info');
    return data;
};



export const callLogout = async () => {
   const {data} = await axios.post<ApiResponse<boolean>>('/api/logout');
   return data;
};

